import { environment } from "../../environment";
import { io } from 'socket.io-client';

export const MsgService = () => {

    let socket:any;

    const connectToSocketServer = async () => {
        try {

            const socketHost = environment.msgUrl;

            socket = io(socketHost,
                {
                    path: '/notifications',
                    transports: ['polling']
                });

        } catch (err) {
            throw err;
        }
    };


    const sendInternalNotification = async (post: string, participants: []) => {

        socket ? console.log('socket exists') : await connectToSocketServer();
        const msgData={
            post,
            participants
        }
        socket.emit("splash", msgData);
    };


    return {
        connectToSocketServer,
        sendInternalNotification
    };


};